import { httpCreate } from './http';
import conf from './config';

const http = httpCreate('/srv/comment');

export const comment = {
	//activityId, content, verifyCode
	comment(params) {
		return http.post('', params);
	},
	//pageNum, pageSize
	activity(id, params) {
		return http.get('/activity/' + id, { params });
	},
	//pageNum, pageSize, page,
	commentMe(params) {
		return http.get('/user/me', { params });
	},
	//pageNum, pageSize, page
	commentBack(params) {
		return http.get('/user/back', { params });
	},
	//pageNum, pageSize
	getCommentPc(id, data, params) {
		return http.post('/activity/' + id + '/pc', data, { params });
	},
	checkPass(data) {
		return http.post('/checkPass', data);
	},
	checkDelete(data) {
		return http.post('/checkDelete', data);
	},
	delComment(id) {
		return http.delete('/' + id);
	},
	//pageNum, pageSize
	selectByParams(data, params) {
		return http.post('/selectByParams', data, { params });
	},
	recoveryList(id) {
		return http.post('/recoverComment/' + id);
	},
	batchRecovery(params, data) {
		return http.post(`/rc`, data, { params });
	},
	clearAll(id) {
		return http.delete(`/clearAll/${id}`);
	},
	exportUrl(activityId, check, nickname, ip, type) {
		return `${conf.apiPath}/srv/comment/export/${activityId}?check=${check}&nickname=${nickname}&ip=${ip}&type=${type}`;
	},
};
